import UnionFind from './UnionFind';

export default UnionFind;
